import Button from 'components/Button';
import Loading from 'components/Loading/index';
import { map, omitBy, orderBy } from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import ReactTable from 'react-table';
import moment from '../../utils/moment';
import selectTableHOC from 'react-table/lib/hoc/selectTable';
import { humanize } from '../../utils/format';
import { ReactComponent as PdfView } from '../../modules/Checks/components/assets/pdf-view-24.svg';
import DateFormats from '../../constants/DateFormats';
import Checkbox from '../Checkbox';

const SelectTable = selectTableHOC(ReactTable);

export default class ChecksTableForm extends Component {
  static propTypes = {
    onSubmit: PropTypes.func.isRequired,
    goBack: PropTypes.func.isRequired,
    loading: PropTypes.bool,
    checkList: PropTypes.array.isRequired,
    parentName: PropTypes.string,
    initialData: PropTypes.array,
    onView: PropTypes.func,
  };

  static defaultProps = {
    checkList: [],
  };

  constructor(props) {
    super(props);
    let selection = {};
    for (let item of props.initialData) {
      selection[item] = true;
    }
    this.state = {
      selectAll: false,
      selection,
    };
  }

  onSubmit = () => {
    const { selection } = this.state;
    const { onSubmit } = this.props;
    onSubmit(
      map(
        omitBy(selection, (sel) => !sel),
        (sel, key) => key,
      ),
    );
  };

  toggleSelection = (key) => {
    let selection = { ...this.state.selection };
    selection[key] = !this.state.selection[key];
    this.setState({ selection });
  };
  toggleAll = () => {
    const selectAll = !this.state.selectAll;
    const selection = {};

    if (selectAll) {
      this.props.checkList.forEach((check) => (selection[check.receiptId] = true));
    }
    this.setState({ selectAll, selection });
  };

  isSelected = (key) => {
    return this.state.selection[key];
  };

  handleViewClick = (event, data) => {
    event.preventDefault();

    this.props.onView(data);
  };

  render() {
    const { checkList } = this.props;
    const tableData = orderBy(
      checkList.map((check) => ({
        ...check,
        formattedData: moment(check.originDate).startOf('day'),
      })),
      ['formattedData', 'originSum'],
      ['asc', 'asc'],
    );
    return (
      <div className="boo">
        <SelectTable
          keyField={'receiptId'}
          toggleSelection={this.toggleSelection}
          selectAll={this.state.selectAll}
          selectType="checkbox"
          minWidth={100}
          toggleAll={this.toggleAll}
          isSelected={this.isSelected}
          SelectAllInputComponent={() => (
            <Checkbox onChange={this.toggleAll} value={this.state.selectAll} />
          )}
          SelectInputComponent={({ row }) => {
            return (
              <Checkbox
                onChange={() => this.toggleSelection(row.receiptId)}
                value={this.state.selection[row.receiptId]}
              />
            );
          }}
          className="fixed-first-column"
          columns={[
            {
              Header: 'Дата чека',
              accessor: 'formattedData',
              Cell: (props) => {
                const data = props.value.format(DateFormats.long);
                return <div className={'ChecksTable__date-cell'}>{data}</div>;
              },
              width: 120,
            },
            {
              Header: 'Сумма, ₽',
              accessor: 'originSum',
              Cell: (props) => {
                const formatedSumma = humanize(props.value);

                return <div className={'ChecksTable__summa-cell'}>{formatedSumma}</div>;
              },
              width: 160,
            },
            {
              Header: 'Категория',
              accessor: 'receiptCategory',
              Cell: (props) => {
                return props.value && props.value.title;
              },
              width: 160,
            },
            {
              Header: 'Описание чека',
              accessor: 'description',
              minWidth: 200,
            },

            {
              Header: null,
              Cell: (props) => (
                <div className={'ChecksTable__actions-cell'}>
                  <PdfView
                    className={'ChecksTable__action ChecksTable__view-action'}
                    onClick={props.columnProps.rest.handlers.onViewClick}
                  />
                </div>
              ),
              accessor: 'receiptId',
              getProps: (tableState, rowInfo) => ({
                handlers: {
                  onViewClick: (e) => this.handleViewClick(e, rowInfo.original.receiptId),
                },
              }),
              maxWidth: 50,
            },
          ]}
          data={tableData}
          defaultPageSize={checkList.length}
          showPagination={false}
        />

        <div className="d-flex w-100 justify-content-between flex-column flex-sm-row mt-3">
          <Button type="button" hasWrapper={false} onClick={this.props.goBack}>
            Назад
          </Button>
          <Button
            onClick={this.onSubmit}
            hasWrapper={false}
            isDisabled={this.props.loading}
            type="button"
          >
            {this.props.loading ? <Loading isLight={true} /> : 'Выбрать чеки'}
          </Button>
        </div>
      </div>
    );
  }
}
